import React,{useEffect, useState} from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { getUserSubEvent } from '../../services/UserServices/UserService';
import PageTitle from '../layouts/PageTitle';
const SubEvents = () => {
 

  const [subEvents,setSubEvents]=useState([]);
 const { id1, id2 } = useParams();   // destructure both ids
 
const location = useLocation();
  const historyData = location.state?.history;
 
 
  useEffect(() => {
  
     const getSubEvents=async()=>{
      try {
      const res = await getUserSubEvent(id1,id2);
      
    
      setSubEvents(res?.data?.data?.subEvents);
      
    } catch (error) {
      console.error(error?.response?.data?.message);
    }
     }
   if(id1){
      getSubEvents();
   }
  }, []);


  return (
    <div className="row">
         <PageTitle
          motherMenu="User List"
          activeMenu={`        ${historyData?.user?.hostName} >  ${historyData?.event?.name?.name} > Sub Events`}
          pathBack={true}   
        />
         <h3 className="mb-4  head font-fm" style={{ color: "#A60000" , fontSize:"50px"}}>

      </h3>
  {subEvents.map((s, i) => (
    <div key={i} className="col-md-4 mb-4">
      <div className="      crds  ">
        <div className="card-body cdd">
          <div>
            <p className="fw-semibold mb-1 title">Sub Event name</p>
            <p className="mb-2 name_field">{s.name}</p>
          </div>
          <div>
            <p className="fw-semibold mb-1 title">Time</p>
            <p className="mb-0 name_field">{s.dateTime}</p>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

  )
}

export default SubEvents
